<template>
    <div class="relative" ref="componentRef">
        <span class="hints" @click="openHintDetails">
            <img class="mr-2" src="./assets/hints.svg">
            Hints
        </span>

        <div class="hint-content" v-if="isHintVisible" v-loading="loading">
            <div class="top_title">
                <div class="top_nav">
                    <i @click="isHintVisible = !isHintVisible" class="el-icon-back text-2xl mr-2 cursor-pointer"></i>
                    Hints
                </div>
            </div>

            <div class="px-3 py-3 main_hint hide_scroll" v-if="activeHint">
                <div class="" v-for="(activehint, index) in activeHint.content" :key="index + 'hints'">
                    <h3 class="text-lg font-semibold capitalize pt-3">{{ activehint ? activehint.header : '' }}</h3>
                    <p :class="[activehint.description ? 'pt-2 pb-3' : '']"
                        v-html="activehint ? activehint.description : ''"> </p>

                    <ul class="list_text" v-for="(point, index) in activehint.points || []" :key="index + 'point_list'">
                        <b>{{ point ? point.title : '' }}</b>
                        <p v-html="point ? point.description : ''"></p>
                        <li v-for="(point, index) in point.steps || []" :key="index + 'hint_point'"
                            v-html="point ? point.description : ''"></li>
                    </ul>
                </div>
                <p class="pt-2 pb-3" v-html="activeHint.sectionNote ? activeHint.sectionNote.description : ''"></p>
            </div>
            <div v-else class="h-56 flex justify-center items-center">
                <h2 class="text-center text-base">No Hints For the current page</h2>
            </div>
        </div>
    </div>
</template>

<script>
import { Hints_content } from "./config.js"

export default {
    name: 'hints_component',
    data() {
        return {
            isHintVisible: false,
            activeHint: {},
            loading: false
        }
    },
    methods: {
        openHintDetails() {
            this.isHintVisible = !this.isHintVisible
        },
        loadHint(route) {
            const specificHint = Hints_content.find(v => v.path == route.path)
            this.activeHint = specificHint
            console.log("this.activeHint:", this.activeHint, specificHint)
        },
        handleOuterClick() {
            const body = document.querySelector('body');

            body.addEventListener('click', (e) => {
                const el = this.$refs.componentRef;

                // Make sure el exists and is a DOM element with .contains()
                if (el && typeof el.contains === 'function') {
                    if (!el.contains(e.target)) {
                        this.isHintVisible = false;
                    }
                } 
            });
        }
    },
    mounted() {
        console.log(this.$route)
        this.loadHint(this.$route)
        this.handleOuterClick()
    },
    watch: {
        $route(to) {
            console.log(to)
            this.loadHint(to)
        }
    }
}
</script>

<style lang="scss" scoped>
.hints {
    @apply inline-flex px-3 py-1 items-center shadow cursor-pointer;
    border-radius: 25px;
}

@media all and (max-width: 767px) {

    /* CSS styles for small screens go here */
    .hint-content {
        background: white;
        left: 0%;
        width: 100vw;
        z-index: 10;
        top: calc(100% + 100px);
        @apply fixed rounded-md shadow;
    }
}

@media all and (min-width: 767px) {

    /* CSS styles for small screens go here */
    .hint-content {
        background: white;
        right: 0%;
        width: 500px;
        z-index: 10;
        font-size: 15px;
        @apply absolute shadow rounded-md;
    }
}

.top_nav {
    display: flex;
    align-items: center;
    font-weight: 600;
}

.top_title {
    display: flex;
    align-items: center;
    padding: 0.5em;
    justify-content: space-between;
}

.main_hint {
    min-height: 300px;
    max-height: 70vh;
    overflow-y: auto;
}

.list_text {
    @apply py-2 px-3;
    list-style-type: disc;

    li {
        @apply py-1
    }
}

.hide_scroll::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide_scroll {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}
</style>